// Returns in the following format: August 1, 2022
export default function getHumanReadableDateFromMillisecondTimestamp(
  millisecondTimestamp: number,
): string {
  return new Date(millisecondTimestamp).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}
